













import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'ListJigyoshoGinko',
  components: {
    CtrlSearchCommonComponents,
  },
  props: {
    jigyoshoCd: {
      type: Number,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'sentakuGinkoCd',
        width: 90,
      },
      {
        text: '銀行名',
        sortable: true,
        value: 'ginkoMei',
        width: 255,
      },
      {
        text: '銀行支店名',
        sortable: true,
        value: 'ginkoShitenMei',
        width: 255,
      },
      {
        text: '種類',
        sortable: true,
        value: 'kozaShurui',
        width: 75,
      },
      {
        text: '口座番号',
        sortable: true,
        value: 'kozaNo',
        width: 127.5,
      },
      {
        text: '口座名義人',
        sortable: true,
        value: 'kozaMeigi',
        width: 255,
      },
    ],
    formatColName: 'sentakuGinkoCd',
  }),
});
